import { css } from 'styled-components';

export const commonColors = {
  textPrimary: '#f8fafc',
  textMuted: '#94a3b8',
  borderSoft: 'rgba(148, 163, 184, 0.28)',
  borderMid: 'rgba(148, 163, 184, 0.35)',
  panelBg: 'rgba(10, 10, 12, 0.62)',
  panelBgSoft: 'rgba(7, 12, 20, 0.42)',
  overlayBg: 'rgba(2, 6, 23, 0.48)',
  accent: '#34d399',
  accentHover: '#5eead4',
  accentText: '#052e1f',
  tableHeaderBg: 'rgba(15, 23, 42, 0.85)',
};

export const commonGlassPanel = css`
  border: 1px solid ${commonColors.borderSoft};
  background: ${commonColors.panelBg};
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(10px);
`;

export const commonSoftGlassPanel = css`
  border: 1px solid ${commonColors.borderSoft};
  background: ${commonColors.panelBgSoft};
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(6px);
`;

export const commonGreenButton = css`
  background-color: ${commonColors.accent} !important;
  border-color: ${commonColors.accent} !important;
  color: ${commonColors.accentText} !important;

  &:hover,
  &:focus {
    background-color: ${commonColors.accentHover} !important;
    border-color: ${commonColors.accentHover} !important;
    color: ${commonColors.accentText} !important;
    box-shadow: none !important;
  }
`;
